import { SVGProps } from 'react';
import Image from 'next/image';

import heroImage from '@/public/images/home/hero.png';
import HeroForm from './hero-form';

const heroFeatures = [
  {
    id: 1,
    text: `Build your production-ready Content API within minutes`,
  },
  {
    id: 2,
    text: `Remote data fetching to federate content from external sources`,
  },
  {
    id: 3,
    text: `Leading GraphQL APIs for Querying, Mutations, and Assets`,
  },
];

function DataPattern(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="230"
      height="146"
      viewBox="0 0 230 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#090E24"
        d="M0 0h2v2H0zM24 0h2v2h-2zM48 0h2v2h-2zM72 0h2v2h-2zM96 0h2v2h-2zM120 0h2v2h-2zM144 0h2v2h-2zM168 0h2v2h-2zM192 0h2v2h-2zM216 0h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 12h2v2h-2zM36 12h2v2h-2zM60 12h2v2h-2zM84 12h2v2h-2zM108 12h2v2h-2zM132 12h2v2h-2zM156 12h2v2h-2zM180 12h2v2h-2zM204 12h2v2h-2zM228 12h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 24h2v2H0zM24 24h2v2h-2zM48 24h2v2h-2zM72 24h2v2h-2zM96 24h2v2h-2zM120 24h2v2h-2zM144 24h2v2h-2zM168 24h2v2h-2zM192 24h2v2h-2zM216 24h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 36h2v2h-2zM36 36h2v2h-2zM60 36h2v2h-2zM84 36h2v2h-2zM108 36h2v2h-2zM132 36h2v2h-2zM156 36h2v2h-2zM180 36h2v2h-2zM204 36h2v2h-2zM228 36h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 48h2v2H0zM24 48h2v2h-2zM48 48h2v2h-2zM72 48h2v2h-2zM96 48h2v2h-2zM120 48h2v2h-2zM144 48h2v2h-2zM168 48h2v2h-2zM192 48h2v2h-2zM216 48h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 60h2v2h-2zM36 60h2v2h-2zM60 60h2v2h-2zM84 60h2v2h-2zM108 60h2v2h-2zM132 60h2v2h-2zM156 60h2v2h-2zM180 60h2v2h-2zM204 60h2v2h-2zM228 60h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 72h2v2H0zM24 72h2v2h-2zM48 72h2v2h-2zM72 72h2v2h-2zM96 72h2v2h-2zM120 72h2v2h-2zM144 72h2v2h-2zM168 72h2v2h-2zM192 72h2v2h-2zM216 72h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 84h2v2h-2zM36 84h2v2h-2zM60 84h2v2h-2zM84 84h2v2h-2zM108 84h2v2h-2zM132 84h2v2h-2zM156 84h2v2h-2zM180 84h2v2h-2zM204 84h2v2h-2zM228 84h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 96h2v2H0zM24 96h2v2h-2zM48 96h2v2h-2zM72 96h2v2h-2zM96 96h2v2h-2zM120 96h2v2h-2zM144 96h2v2h-2zM168 96h2v2h-2zM192 96h2v2h-2zM216 96h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 108h2v2h-2zM36 108h2v2h-2zM60 108h2v2h-2zM84 108h2v2h-2zM108 108h2v2h-2zM132 108h2v2h-2zM156 108h2v2h-2zM180 108h2v2h-2zM204 108h2v2h-2zM228 108h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 120h2v2H0zM24 120h2v2h-2zM48 120h2v2h-2zM72 120h2v2h-2zM96 120h2v2h-2zM120 120h2v2h-2zM144 120h2v2h-2zM168 120h2v2h-2zM192 120h2v2h-2zM216 120h2v2h-2z"
      />
      <path
        fill="#F0F2F7"
        d="M12 132h2v2h-2zM36 132h2v2h-2zM60 132h2v2h-2zM84 132h2v2h-2zM108 132h2v2h-2zM132 132h2v2h-2zM156 132h2v2h-2zM180 132h2v2h-2zM204 132h2v2h-2zM228 132h2v2h-2z"
      />
      <path
        fill="#090E24"
        d="M0 144h2v2H0zM24 144h2v2h-2zM48 144h2v2h-2zM72 144h2v2h-2zM96 144h2v2h-2zM120 144h2v2h-2zM144 144h2v2h-2zM168 144h2v2h-2zM192 144h2v2h-2zM216 144h2v2h-2z"
      />
    </svg>
  );
}

type HeroProps = {
  page: {
    title: string;
    subTitle: string;
  };
};

export default function Hero({ page }: HeroProps) {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-6 lg:grid lg:grid-cols-2 lg:gap-12">
      <div className="w-full mx-auto lg:mx-0 max-w-3xl lg:max-w-xl text-haiti">
        <h1 className="font-bold text-3xl md:text-5xl leading-tight">
          {page.title}
        </h1>

        <h2 className="mt-7 text-base md:text-lg leading-normal">
          {page.subTitle}
        </h2>

        <ul className="mt-8 space-y-4 lg:space-y-6">
          {heroFeatures.map((feature) => (
            <li
              key={feature.id}
              className="text-base font-semibold flex items-center"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle opacity="0.2" cx="9" cy="9" r="9" fill="#F5487F" />
                <circle
                  r="3.52174"
                  transform="matrix(1 0 0 -1 9.00001 8.99975)"
                  fill="#F5487F"
                />
              </svg>

              <p className="ml-4">{feature.text}</p>
            </li>
          ))}
        </ul>

        <HeroForm className="mt-8" />

        <a
          href="https://app.graphcms.com/signup"
          rel="noopener noreferrer"
          className="text-light-haiti mt-6 lg:mt-12 flex flex-col sm:block font-medium group"
        >
          Create a free-forever developer account.{` `}
          <span className="text-rose">
            Get Started{` `}
            <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
              &#8594;
            </span>
          </span>
        </a>
      </div>

      <div className="sm:mx-auto sm:max-w-3xl sm:px-6">
        <div className="lg:py-12 sm:relative mt-12 lg:mt-0 sm:py-16 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <div className="relative sm:px-0 lg:max-w-6xl lg:h-full lg:pl-12">
            <div className="hidden sm:block">
              <DataPattern
                className="absolute -bottom-3 right-1/2 ml-3 lg:left-0"
                aria-hidden="true"
              />
              <DataPattern
                className="absolute -top-4 -right-12"
                aria-hidden="true"
              />
            </div>
            <div className="lg:w-[1130px] lg:h-[621px]">
              <Image src={heroImage} quality={100} objectFit="cover" priority />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
